module.exports = __webpack_public_path__ + "ef900ea4b52e648e52b9b2cf4d92d9ba.svg";